import React from 'react';
import { observer } from 'mobx-react';
import { reverse } from 'named-urls';
import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { useParams } from 'react-router-dom';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import routes from 'core/routes';
import { useStore } from 'utils/hooks/store';

import Grid from 'components/Grid';

import { useNavBarHeight } from 'utils/hooks/navbar';

import { tasksTableBasicColumns } from 'containers/Tasks/components/TasksTable/TasksTable';

const RelatedActionsToAudits: React.FunctionComponent = () => {
  const { routing, formDetails } = useStore();
  const navBarHeight = useNavBarHeight();

  const onRowClick: GridEventListener<'rowClick'> = (task: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.tasks.details, { taskId: task.row.uuid }));
  };

  const params = useParams<{ entityId: string }>();
  const entityId = params.entityId as string;

  React.useEffect(() => {
    const fetchDetails = async (): Promise<void> => {
      await formDetails.loadDetails(entityId);
    };

    fetchDetails();
  }, [entityId]);

  return (
    <Record
      Header={
        <MainHeader
          title={`Related Tasks to ${formDetails.details?.name || ''}`}
          breadcrumbs={[
            { label: 'Audits', link: routes.dashboard.audits.toString() },
            { label: 'Forms', link: routes.dashboard.audits.forms.toString() },
            { label: 'Form Details', link: reverse(routes.dashboard.audits.forms.details, { formId: entityId }) },
            {
              label: 'Related Tasks',
              link: reverse(routes.dashboard.audits.relatedTasks, { formId: entityId }),
            },
          ]}
        />
      }
      Content={(onError) => (
        <Grid
          basicColumns={tasksTableBasicColumns}
          entity="action"
          onError={onError}
          onRowClick={onRowClick}
          dataURL={`tasks/?inspection=${entityId}&related=true`}
          sortBy={{ field: 'dueDate', sort: 'asc' }}
          customNoRowsText="No tasks have been created yet"
        />
      )}
      navBarHeight={navBarHeight}
    />
  );
};

export default observer(RelatedActionsToAudits);
